module.exports = __webpack_public_path__ + "static/media/SativaDomCF.dff35318.png";